import React,{useState,useEffect} from 'react';
import PartnerCard from '../PartnerCard/PartnerCard';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";

const PartnerInfo = () => {

    const [parnterInfo, setParnterInfo] = useState(null);
    const [partnersContent, setPartnersContent] = useState(null);
  
    useEffect(() => {
        client
            .query({
                query: queries.partnerInfo,
            })
            .then((response) => {
                const partnersContent = response.data.allPartners.edges[0].node;
                setPartnersContent(partnersContent);
                setParnterInfo(partnersContent.partner_info);

            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (

        <div className="row gx-2 gy-2">
            <div className="col-md-4">
                <h5 className="section-title">{partnersContent?.title[0]?.text}</h5>
                <h3 className="subtitle">{partnersContent?.sub_title[0]?.text}</h3>
                <p className="body-text">{partnersContent?.description[0]?.text}</p>
            </div>
            <div className="col-md-8 ps-md-5">
                <div className="row gy-2  pt-md-5">
                    {parnterInfo?.map(Info => <PartnerCard key={Date.now() + Math.random()} partnerInfo={Info}></PartnerCard>)}
                </div>
            </div>

        </div>
    );
};

export default PartnerInfo;